import { StyledProps } from '@components/3rd-party/mui'
import { PrimaryButton } from '@components/UI-Components/PrimaryButton'
import { Paper } from '@material-ui/core'
import Portal from '@material-ui/core/Portal'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import { WithTranslationProps, withTranslation } from 'react-i18next'

const styles = theme => ({
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  root: {
    width: 528,
    padding: theme.spacing(4)
  },
  button: {
    margin: theme.spacing(1)
  },
  buttonRoot: {
    textAlign: 'center'
  },
  logout: {
    textAlign: 'center'
  }
})

interface MyProps extends StyledProps {
  errorMessage?: string
  t?: WithTranslationProps['i18n']['t']
}

@((withStyles as any)(styles))
@((withTranslation as any)())
export class AuthorizationError extends React.Component<MyProps> {
  moveToSite = () => {
    window.location.replace('/')
  }

  logout = () => {
    window.location.replace('/logout')
  }

  render() {
    const { classes, errorMessage, t } = this.props
    return (
      <Portal>
        <div className={classes.container}>
          <Paper className={classes.root} elevation={1} tabIndex={1}>
            <Typography variant='h4' component='h3'>
              {t('common.warnings.unauthorizedAccess', 'Unauthorized Access')}
            </Typography>
            <br />
            <Typography>
              {errorMessage
                ? t(
                    'common.warnings.externalClient.externalClientUnauthorizedMessage',
                    `You are not authorized to view this page. Looks like you don't have access for requested client.`
                  )
                : t(
                    'common.warnings.defaultErrorMessage',
                    'You are not authorized to view this page'
                  )}
              <br />
              <br />
            </Typography>
            <PrimaryButton
              color='primary'
              className={classes.button}
              classes={{ root: classes.buttonRoot }}
              onClick={this.moveToSite}
            >
              {t('common.label.backToSite', 'Back to our site')}
            </PrimaryButton>
            <PrimaryButton
              color='primary'
              className={classes.button}
              classes={{ root: classes.logout }}
              onClick={this.logout}
            >
              {t('sidebar.footer.logout', 'Logout')}
            </PrimaryButton>
          </Paper>
        </div>
      </Portal>
    )
  }
}
